export class Blog {
    id: string;
    body: string = '';
    validFrom: Date = new Date();
    validTo: Date;
    isActive: boolean = false;
}